import React, { useEffect, useState, useContext } from 'react';
import { List, ListItem, ListItemText, ThemeProvider } from "@mui/material";
import theme from "../assets/themes/theme";
import { Typography, AppBar, Toolbar, Card, CardContent, Grid, Box, TextField, Button, Snackbar, Alert } from '@mui/material';
import logoST from '../assets/images/LogoSTL.svg';
import logoLolify from "../assets/images/Lilofy_color.png";
import "../assets/css/App.css";
import { useParams, useNavigate } from 'react-router-dom';
import { account } from '../shared/Utils.js'
import { EnumConfiguracion } from '../shared/Enumerables.js'
import { RootStoreContext } from '../app/store/root'
import { observer } from "mobx-react-lite";
import Alerts from "../shared/Alerts";
import LogisticBackdropStore from "../shared/LogisticBackdrop";

const fabStyle = {
    position: 'fixed',
    bottom: 16,
    right: 16,
    color: 'white',
    fontSize: '1.3rem'
};

function RecoveryPass() {
    const rootStore = useContext(RootStoreContext);
    const { getParameter } = rootStore.configuracionStore;
    const navigate = useNavigate();
    const { id } = useParams();
    const [linkValido, setLinkValido] = React.useState(null)

    const [longitudMaxima, setLongitudMaxima] = useState(undefined);
    const [requiereNumeros, setRequiereNumeros] = useState(undefined);
    const [longitudMinima,  setLongitudMinima] = useState(undefined);
    const [requiereMayusculas, setRequiereMayusculas] = useState(undefined);
    const [requiereCaracteresEspeciales, setRequiereCaracteresEspeciales] = useState(undefined);

    const [contrasenia, setContrasenia] = React.useState('')
    const [confirmarContrasenia, setConfirmarContrasenia] = React.useState('')
    const [errorContrasenia, setErrorContrasenia] = React.useState(false)
    const [errorContraseniaMsj, setErrorContraseniaMsj] = React.useState('')
    const [errorContrasenia2, setErrorContrasenia2] = React.useState(false)
    const [errorContraseniaMsj2, setErrorContraseniaMsj2] = React.useState('')

    const onChangeContrasenia = (e) => {
        setContrasenia(e.target.value)
    }

    const onChangeConfirmarContrasenia = (e) => {
        setConfirmarContrasenia(e.target.value)
    }

    useEffect(() => {
        document.title = 'Lilofy | Recuperar Contraseña';
        loadData();
        getParametersInitialForPasswordValidation();
    }, [])

    const loadData = async () => {
        rootStore.logisticBackdropStore.openLoading()
        let codigoValido = await validarCodigoRecuperarContrasenia()   
        if (!codigoValido) {
            setLinkValido(false)
            setTimeout(() => { rootStore.logisticBackdropStore.closeLoading() }, 500)
        } else {
            setLinkValido(true)
            setTimeout(() => { rootStore.logisticBackdropStore.closeLoading() }, 500)
        }
    }

    const getParametersInitialForPasswordValidation = async () => {
        setLongitudMinima(await getParameter(EnumConfiguracion.Contrasenia_Longitud_Minima));
        setLongitudMaxima(await getParameter(EnumConfiguracion.Contrasenia_Longitud_Maxima));
        setRequiereNumeros(await getParameter(EnumConfiguracion.Contrasenia_Requiere_Numeros));
        setRequiereMayusculas(await getParameter(EnumConfiguracion.Contrasenia_Requiere_Mayusculas));
        setRequiereCaracteresEspeciales(await getParameter(EnumConfiguracion.Contrasenia_Requiere_Caracteres_Especiales));        
    }

    const validarCodigoRecuperarContrasenia = () => {
        return new Promise(resolve => {
            try {
                fetch(`${process.env.REACT_APP_API_LOGISTICA}/api/Auth/ValidarCodigoRecuperarContrasenia/${id}`,
                    {
                        method: 'GET',
                        mode: 'cors',
                        cache: 'no-cache',
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).then((response) => response.json()).then((response) => {
                        if (response.success) {
                            resolve(response.data)
                        } else {
                            resolve(false)
                        }
                    });
            } catch (error) {
                resolve(false)
            }
        })
    }

    const validarContrasenia = () => {
        setErrorContraseniaMsj('')
        setErrorContrasenia(false)
        setErrorContraseniaMsj2('')
        setErrorContrasenia2(false)
        if (contrasenia?.length < parseInt(longitudMinima.valor) || contrasenia?.length > parseInt(longitudMaxima.valor)) {
            setErrorContraseniaMsj('La contraseña no tiene la longitud requerida.')
            setErrorContrasenia(true)
            return
        }
        if (requiereMayusculas?.valor == 'True' && contrasenia.search(/[A-Z]/i) < 0) {
            setErrorContraseniaMsj('La contraseña requiere al menos una MAYÚSCULA.')
            setErrorContrasenia(true)
            return
        }

        if (requiereNumeros?.valor == 'True' && contrasenia.search(/[0-9]/) < 0) {
            setErrorContraseniaMsj('La contraseña requiere al menos un número.')
            setErrorContrasenia(true)
            return
        }
        //ñÑ\-_¿.#¡
        //!@#$%^&*.
        if (requiereCaracteresEspeciales?.valor == 'True' && contrasenia.search(/(?=.*[ñÑ\-_¿.#¡!@$%^&*])/) < 0) {
            setErrorContraseniaMsj('La contraseña requiere al menos un caracter especial.')
            setErrorContrasenia(true)
            return
        }

        if (contrasenia != confirmarContrasenia) {
            setErrorContraseniaMsj2('Las contraseñas no coinciden.')
            setErrorContrasenia2(true)
            return
        }
        if (!errorContrasenia && !errorContrasenia2) {
            RecuperarContrasenia();
        }
    }

    const RecuperarContrasenia = () => {
        rootStore.logisticBackdropStore.openLoading()
        let recuperarContrasenia = {
            codigo: id,
            newPassword: contrasenia,
            confirmPassword: confirmarContrasenia
        }
        fetch(`${process.env.REACT_APP_API_LOGISTICA}/api/Auth/RecuperarContrasenia`,
            {
                method: 'POST',
                mode: 'cors',
                cache: 'no-cache',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(recuperarContrasenia)
            }).then((response) => response.json()).then((response) => {
                rootStore.logisticBackdropStore.closeLoading()                
                if (response.success) {
                    if (response.data) {
                        rootStore.alertStore.alertSuccess('Proceso realizado con éxito.')
                        setTimeout(() => { navigate('/') }, 1500)
                    }
                    else {
                        rootStore.alertStore.alertError('Error al intentar cambiar la contraseña.')
                    }
                }
            }, error => {
                rootStore.alertStore.alertError('Error al intentar cambiar la contraseña.')
                rootStore.logisticBackdropStore.closeLoading()
            });
    }

    return (
        <ThemeProvider theme={theme}>
            <LogisticBackdropStore />
            <Alerts />
            <Box minHeight={'95vh'}>
                <Grid container direction={'column'} justifyContent="center" alignItems="center">
                    {

                        linkValido === true &&
                        <div>
                            <Grid item sx={{ textAlign: 'center' }}>
                                <Box display={'flex'} justifyContent={'center'}>
                                    <img src={logoLolify} alt="logo" width={'20%'} />
                                </Box>
                            </Grid>
                            <Grid item sx={{ display: 'flex' }} justifyContent="center">
                                <Card  >
                                    <CardContent className='card-body'>
                                        <Grid container direction={'column'} justifyContent="center" alignItems="center">
                                            <Grid item>
                                                <h6><strong>CAMBIAR CONTRASEÑA</strong></h6>
                                            </Grid>
                                            <Grid item container direction={'column'} mt={1}>
                                                <p className='textJustify'>
                                                    La contraseña debe tener los siguientes elementos:
                                                </p>
                                                <List dense="true">
                                                    {
                                                        longitudMinima != null &&
                                                        <ListItem>
                                                            <ListItemText primary={`Mínimo ${longitudMinima.valor} caracteres.`} />
                                                        </ListItem>
                                                    }
                                                    {
                                                        longitudMaxima != null &&
                                                        <ListItem>
                                                            <ListItemText primary={`Máximo ${longitudMaxima.valor} caracteres.`} />
                                                        </ListItem>
                                                    }
                                                    {
                                                        requiereMayusculas?.valor === 'True' &&
                                                        <ListItem>
                                                            <ListItemText primary="Al menos una MAYÚSCULA." />
                                                        </ListItem>
                                                    }
                                                    {
                                                        requiereNumeros?.valor === 'True' &&
                                                        <ListItem>
                                                            <ListItemText primary="Al menos un número." />
                                                        </ListItem>
                                                    }
                                                    {
                                                        requiereCaracteresEspeciales?.valor === 'True' &&
                                                        <ListItem>
                                                            <ListItemText primary="Al menos un caracter especial." />
                                                        </ListItem>
                                                    }
                                                </List>
                                            </Grid>
                                            <Grid item>
                                                <Box component="form" noValidate >
                                                    <TextField
                                                        size="small"
                                                        margin="normal"
                                                        required
                                                        fullWidth
                                                        id="newPass"
                                                        label="Nueva contraseña"
                                                        name="newPass"
                                                        onChange={e => onChangeContrasenia(e)}
                                                        error={errorContrasenia}
                                                        helperText={errorContraseniaMsj}
                                                        type="password"
                                                    />

                                                    <TextField
                                                        size="small"
                                                        margin="normal"
                                                        required
                                                        fullWidth
                                                        id="confirmNewPass"
                                                        label="Confirmar nueva contraseña"
                                                        name="confirmNewPass"
                                                        onChange={e => onChangeConfirmarContrasenia(e)}
                                                        error={errorContrasenia2}
                                                        helperText={errorContraseniaMsj2}
                                                        type="password"
                                                    />

                                                    <div className='mt-2 mb-2 text-center'>
                                                        <Button
                                                            variant="contained"
                                                            sx={{ ml: 2 }}
                                                            onClick={validarContrasenia}
                                                            disabled={(contrasenia.length < 1 || contrasenia.length < 1)}>
                                                            Cambiar contraseña
                                                        </Button>
                                                    </div>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </div>
                    }
                    {
                        linkValido === false &&
                        <Grid item sx={{ display: 'flex', marginTop: '100px' }} justifyContent="center">
                            <Card>
                                <CardContent className='card-body'>
                                    <Grid container direction={'column'} justifyContent="center" alignItems="center">
                                        <Grid item>
                                            <h6><strong>LINK EXPIRADO</strong></h6>
                                        </Grid>
                                        <Grid item container direction={'column'} mt={1}>
                                            <p className='textJustify'>
                                                El tiempo de uso del link ha expirado, por favor solicite un nuevo correo para cambiar la contraseña.
                                            </p>
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </Grid>
                    }
                </Grid>
            </Box>
            {/* FOOTER */}
            <footer style={{ color: "gray", width: '100%', height: '5vh', alignItems: 'center', justifyContent: 'center', display: 'flex' }}>
                <Box display="flex" flexWrap="wrap" alignItems="center" justifyContent={"center"}>
                <a href="https://www.axsistec.com/web/Index.html">
                    <Typography
                        color="textSecondary"
                        component="p"
                        variant="caption"
                        gutterBottom={false}
                    
                    >
                        Powered by Axsis Tecnología © 2023.
                    </Typography>
                </a>
                </Box>
            </footer>
        </ThemeProvider>
    )
}

export default observer(RecoveryPass);